import React, { useState, useEffect } from 'react';
import { fetchBlog } from '../functions/fetchBlog';
import renderContent from '../functions/renderContent';
import { fetchAllPlans } from '../functions/fetchAllPlans';

const Main: React.FC = () => {
  const [blog, setBlog] = useState<Blog | null>(null);

  useEffect(() => {
    const getBlog = async () => {
      const blogData = await fetchBlog(1); // Assuming 1 is the blog ID
      setBlog(blogData);
    };

    getBlog();
  }, []);

  return (
    <div>
      <h1>{blog ? blog.title : 'Loading...'}</h1>
      <div>{blog ? blog.content : 'Loading content...'}</div>
    </div>
  );
};

export default Main;